module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"url":{"label":"Adres URL","placeholder":"https://"},"name":{"label":"Nazwa","placeholder":"Podaj nazwę swojej strony, bloga lub profilu social media"},"categories":{"label":"Kategoria","placeholder":"Wybierz"},"type":{"label":"Typ","placeholder":"Wybierz"},"button":{"submit":"Dalej"},"msgSuccess":"Strona „{name}” została pomyślnie utworzona."}}')
  delete Component.options._Ctor
}
